import { FlyMouseEvent } from '@customerio/fly-components/types/events';

interface Args<T> {
  models: T[];
  singleModel: T;
  selectedItems: T[];
  index: number;
  checked: boolean;
  totalRecs: number;
  metadata: { event: FlyMouseEvent<HTMLInputElement> };
  shiftSelectStart: number | null;
  shiftSelectEnd: number | null;
}

/** When clicked together with "shift" key, then selects all entries from the previous click
 *  to the current. Allowing a range selection.
 *  reference: https://github.com/customerio/ui/pull/4611
 *
 *  Relies on mutating non-primitive values
 */
export default function rangeSelectionHelper<T>(args: Args<T>) {
  let { index, checked, totalRecs, shiftSelectStart, shiftSelectEnd } = args;
  let tempShiftSelectStart = shiftSelectStart;
  let tempShiftSelectEnd;
  let allSelected: boolean;

  if (args.metadata.event.shiftKey && shiftSelectStart != null && shiftSelectEnd != null) {
    if (!checked) {
      args.metadata.event.preventDefault();
    }

    let removeStart = Math.min(shiftSelectStart, shiftSelectEnd);
    let removeEnd = Math.max(shiftSelectStart, shiftSelectEnd);

    let itemsToRemove = args.models.slice(removeStart, removeEnd + 1);
    args.selectedItems.removeObjects(itemsToRemove);

    tempShiftSelectEnd = index;

    let start = Math.min(index, shiftSelectStart);
    let end = Math.max(index, shiftSelectStart);

    let itemsToSelect = args.models.slice(start, end + 1);
    args.selectedItems.addObjects(itemsToSelect);

    allSelected = args.selectedItems.length === totalRecs;
  } else {
    if (checked) {
      args.selectedItems.addObject(args.singleModel);
      allSelected = args.selectedItems.length === totalRecs;
    } else {
      allSelected = false;
      args.selectedItems.removeObject(args.singleModel);
    }

    tempShiftSelectStart = index;
    tempShiftSelectEnd = index;
  }

  return {
    tempShiftSelectStart,
    tempShiftSelectEnd,
    allSelected,
  };
}
